import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { environment } from "../../environments/environment";
import { PoTableColumn } from "@po-ui/ng-components";

@Injectable({
  providedIn: "root",
})
export class AreaTecnicaClienteService {
  urlAcervos = `${environment.API}acervotecnico`;
  urlSimilar = `${environment.API}similar`;
  urlProdutos = `${environment.API}produtos`;
  headers = new HttpHeaders({'authorization':sessionStorage.getItem("token")});
  
  constructor(private http: HttpClient) {}

 

  getAcervos(segmento): Observable<any> {
    return this.http.post(this.urlAcervos, { seguimento: segmento },{headers: this.headers});
  }

  getSimilarColumns(): Array<PoTableColumn> {
    return [
      { property: "codigo", type: "number", width: "30%" },
      { property: "produto", width: "40%" },
      { property: "similar", width: "20%" },
    ];
  }

  getAcervoColumns(): Array<PoTableColumn> {
    return [
      { property: "titulo", width: "20%" },
      { property: "descricao", width: "60%",label:"Descrição" },
      { property: "link",type:"link",label:"Link",width: "20%" },
    ];
  }

  getProdutosColumns(): Array<PoTableColumn> {
    return [
      { property: "codigo", type: "number", width: "30%" },
      { property: "produto", width: "40%" },
      {property: 'ean', width: '15%' },
      { property: "ncm", width: "20%" },
    ];
  }

  getProdutos(segmento, filtro): Observable<any> {
    return this.http.post(this.urlProdutos, { segmento, filter: filtro },{headers: this.headers});
  }

  getSimilar(codigo: String): Observable<any> {
    return this.http.post(this.urlSimilar, { codigo },{headers: this.headers});
  }
}
